import React from 'react';
import { Carousel, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Link इम्पोर्ट करें
import b2Image from '../images/EducateaChild.jpg';
import b3Image from '../images/SkillDevelopmentt.jpg';

const HomeSlider: React.FC = () => {
  return (
    <Carousel fade className="mt-5 custom-carousel">
      <Carousel.Item>
        <div className="carousel-overlay">
          <img className="d-block w-100" src={b2Image} alt="Trustble NGO Company" />
          <div className="carousel-content">
            <h1>Free Education for All</h1>
            <p>Empowering youth through schools, colleges, and skill centers.</p>
            <Link to="/donate/">
              <Button variant="danger" className="  me-2">
                Donate Us
              </Button>
            </Link>
            <Link to="/education">
            <Button variant="outline-light">Learn More</Button>
            </Link>
          </div>
        </div>
      </Carousel.Item>
      
      <Carousel.Item>
        <div className="carousel-overlay">
          <img className="d-block w-100" src={b3Image} alt="Slide 2" />
          <div className="carousel-content">
            <h1>Skill Development</h1>
            <p>Building a skilled future with vocational training.</p>
            <Link to="/donate/">
              <Button variant="danger" className="  me-2">
                Donate Us
              </Button>
            </Link>
            <Button variant="outline-light">Learn More</Button>
          </div>
        </div>
      </Carousel.Item>
    </Carousel>
  );
};

export default HomeSlider;
